"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEME = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
const functions_1 = require("./functions");
const types_1 = require("./types");
exports.THEME = (0, material_1.createTheme)({
    palette: {
        mode: "dark",
        background: {
            default: types_1.BG_COLOR,
            paper: types_1.PAPER_COLOR,
        },
    },
});
function LoginApplication() {
    const [email, setEmail] = react_1.default.useState("");
    const [password, setPassword] = react_1.default.useState("");
    const [mfa_enabled, setMfaEnabled] = react_1.default.useState(false);
    const [otp, setOtp] = react_1.default.useState("");
    const year = new Date().getFullYear();
    const [show_error, setShowError] = react_1.default.useState(false);
    const [show_success, setShowSuccess] = react_1.default.useState(false);
    const [error_message, setErrorMessage] = react_1.default.useState("");
    const [success_message, setSuccessMessage] = react_1.default.useState("");
    const [password_resetting, setPasswordResetting] = react_1.default.useState(false);
    const reset = () => __awaiter(this, void 0, void 0, function* () {
        setPasswordResetting(true);
        try {
            yield (0, functions_1.post)("/login/", { email }, "PUT");
            setSuccessMessage("Password reset link sent to your email address");
            setShowSuccess(true);
        }
        catch (error) {
            setErrorMessage(error);
            setShowError(true);
            setPasswordResetting(false);
            console.error(error);
        }
    });
    const login = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const resp = yield (0, functions_1.post)("/login/", { email, password, otp }, "POST");
            if (resp.mfa_enabled) {
                setMfaEnabled(true);
            }
            else {
                window.location.href = "/";
            }
        }
        catch (error) {
            setErrorMessage(error);
            setShowError(true);
        }
    });
    return ((0, jsx_runtime_1.jsxs)(material_1.ThemeProvider, { theme: exports.THEME, children: [(0, jsx_runtime_1.jsx)(material_1.CssBaseline, {}), show_error && ((0, jsx_runtime_1.jsx)(material_1.Snackbar, { open: show_error, autoHideDuration: 4000, anchorOrigin: {
                    vertical: "top",
                    horizontal: "center",
                }, onClose: () => setShowError(false), children: (0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "error", onClose: () => {
                        setShowError(false);
                    }, children: error_message }) })), show_success && ((0, jsx_runtime_1.jsx)(material_1.Snackbar, { open: show_success, autoHideDuration: 4000, anchorOrigin: {
                    vertical: "top",
                    horizontal: "center",
                }, onClose: () => setShowSuccess(false), children: (0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "success", onClose: () => {
                        setShowSuccess(false);
                    }, children: success_message }) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, flexDirection: "column", justifyContent: "center", alignItems: "center", flexGrow: 1, spacing: 2, children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { flexGrow: 1 }), (0, jsx_runtime_1.jsx)(material_1.Grid, { sx: { mb: 4 }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h5", sx: {
                                fontFamily: "Comfortaa",
                                fontSize: 100,
                                color: types_1.LOGO_COLOR,
                                fontWeight: "bold",
                            }, children: "<REPO/>" }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { label: "Email", type: "text", sx: { width: 400 }, size: "small", autoFocus: true, onChange: (event) => {
                                if ((0, functions_1.validateEmail)(event.target.value)) {
                                    setEmail(event.target.value);
                                }
                            } }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { label: "Password", type: "password", sx: { width: 400 }, size: "small", onKeyUp: (event) => {
                                if (event.key === "Enter") {
                                    login();
                                }
                            }, onChange: (event) => {
                                setPassword(event.target.value);
                            } }) }), mfa_enabled && ((0, jsx_runtime_1.jsx)(material_1.Grid, { sx: { mb: 4 }, children: (0, jsx_runtime_1.jsx)(material_1.TextField, { label: "OTP", type: "text", sx: { width: 400 }, slotProps: {
                                htmlInput: {
                                    max: 6,
                                    autocomplete: "one-time-code",
                                    id: "mfaCode",
                                },
                            }, onKeyUp: (event) => {
                                if (event.key === "Enter") {
                                    login();
                                }
                            }, onChange: (event) => {
                                setOtp(event.target.value);
                            } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, { children: (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "contained", sx: { width: 400 }, disabled: email == "" || password == "", onClick: login, children: "LOGIN" }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { children: (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "outlined", sx: { width: 400 }, startIcon: (0, jsx_runtime_1.jsx)("img", { src: "https://static.chacess.app/static/img/google.png", style: { width: 20, height: 20 } }), href: "/login/google/", children: "LOGIN WITH GOOGLE" }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { children: (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "outlined", sx: { width: 400 }, startIcon: (0, jsx_runtime_1.jsx)("img", { src: "https://static.chacess.app/static/img/microsoft.svg", style: { width: 20, height: 20 } }), href: "/login/microsoft/", children: "LOGIN WITH MICROSOFT" }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { sx: { width: 400 }, children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { container: true, justifyContent: "space-between", children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: "Please type your email address to enable this option", children: password_resetting ? ((0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "text", size: "small", disabled: email === "", children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, { size: 20, color: "inherit" }) }) })) : ((0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "text", size: "small", disabled: email === "", onClick: reset, children: "Forgot Password" }) })) }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { children: (0, jsx_runtime_1.jsx)(material_1.Button, { variant: "outlined", size: "small", href: "/signup/", children: "SIGNUP" }) })] }) }), (0, jsx_runtime_1.jsx)(material_1.Grid, { flexGrow: 1 }), (0, jsx_runtime_1.jsx)(material_1.Grid, { children: (0, jsx_runtime_1.jsxs)(material_1.Typography, { variant: "caption", children: ["\u00A9 ", year, " Chace Software Solutions Private Limited"] }) })] })] }));
}
const root = client_1.default.createRoot(document.getElementById("root"));
root.render((0, jsx_runtime_1.jsx)(LoginApplication, {}));
